const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const MONTHS_FULL = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export function fmtDate(str) {
  if (!str) return "—";
  const d = new Date(str + (str.length === 10 ? "T00:00:00" : ""));
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
}

export function fmtDateFull(str) {
  if (!str) return "—";
  const d = new Date(str + (str.length === 10 ? "T00:00:00" : ""));
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function fmtTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${d.getDate()} ${MONTHS[d.getMonth()]}, ${d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}`;
}

export function monthName(m) {
  return MONTHS_FULL[m - 1];
}

export { MONTHS, MONTHS_FULL };
